import React, {memo, useEffect, useState} from "react";
import {getImagePlaceholderByType} from "../../../_metronic/_helpers";
//components:
import {CustomTooltip} from "../index";
import {CircularProgress} from "@material-ui/core";

export const ImagesGroup = memo(
    ({className = "", isLoading = true, type = "", images = [], max = 4, toggleImage = () => {}, placeholder = ""}) => {
        const [showAllImages, setShowAllImages] = useState(false);
        const imagePlaceholder = getImagePlaceholderByType(type);
        const isVideoType = type === "videos";

        const defaultItemsToShow = () => {
            if (images?.length) {
                return images.map((image, i) => {
                    const zIndex = images.length - i;
                    const isExtra = i + 1 > max;
                    const imageSrc = image.media_url || imagePlaceholder;

                    return (
                        <CustomTooltip
                            key={i}
                            config={{
                                text: image.name || "",
                                placement: "top",
                            }}
                        >
                            <div
                                key={image.id}
                                className={`imageItem ${
                                    isExtra ? (showAllImages ? "isExtra showExtras" : "isExtra") : ""
                                }`}
                                style={{zIndex}}
                                onClick={() => toggleImage(image)}
                            >
                                <img
                                    className={`${image.active ? "active" : ""} ${isVideoType ? "videoImage" : ""}`}
                                    src={imageSrc}
                                    alt={""}
                                />
                            </div>
                        </CustomTooltip>
                    );
                });
            }
        };

        const toggleShowExtraImages = () => {
            const showMoreText = `${showAllImages ? "-" : "+"} ${images?.length - max}`;

            if (images && images.length > max)
                return (
                    <div
                        className="toggleShowExtraImages rounded-circle"
                        onClick={() => setShowAllImages(!showAllImages)}
                    >
                        {showMoreText}
                    </div>
                );

            return "";
        };

        return (
            <div className={`imageGroup_container ${className}`}>
                {images?.length ? (
                    <div className={`${isLoading ? "loading" : ""} imageGroup`}>
                        {defaultItemsToShow()}
                        {toggleShowExtraImages()}
                    </div>
                ) : (
                    <p className={`${isLoading ? "loading" : ""} imageGroup_placeholder`}>{placeholder}</p>
                )}
                <div className={`spinner_container ${isLoading ? "loading" : ""}`}>
                    <CircularProgress className="w-30px h-30px" />
                </div>
            </div>
        );
    },
    (prevProps, nextProps) =>
        prevProps.className === nextProps.className &&
        prevProps.isLoading === nextProps.isLoading &&
        prevProps.type === nextProps.type &&
        prevProps.images === nextProps.images &&
        prevProps.max === nextProps.max &&
        prevProps.placeholder === nextProps.placeholder &&
        prevProps.toggleImage === nextProps.toggleImage
);
